import StoredLayout from '../../layouts/StoredLayout'
import SkillVendorAdmin from './SkillVendorAdmin'
export default StoredLayout(SkillVendorAdmin)
